export enum FlagsActionTypes {
  SetIsInProgressFlag = 'SET_IS_IN_PROGRESS_FLAG',
  SetSucceededFlag = 'SET_SUCCEEDED_FLAG',
  SetErrorFlag = 'SET_ERROR_FLAG',
  SetActionedFlag = 'SET_ACTIONED_FLAG',
  ResetIsInProgressFlags = 'RESET_IS_IN_PROGRESS_FLAGS',
  ResetSucceededFlags = 'RESET_SUCCEEDED_FLAGS',
  ResetErrorFlags = 'RESET_ERROR_FLAGS',
  ResetActionedFlags = 'RESET_ACTIONED_FLAGS',
  ResetAllFlags = 'RESET_ALL_FLAGS',
}
